<template>
  <div class="shadow br8 p-3 mb-3">
    <div class="d-flex align-items-center flex-wrap">
      <div class="mr-3" @click="goToProf">
        <a-badge :offset="[-5, getBadgeLength(revieweeData.image, reviewData.author.picture)]">
          <template #count>
            <img v-if="reviewData.author.picture" :src="reviewData.author.picture" alt="dp" class="hw24 rounded-circle" :style="{ border: '1px solid #F8FAFD' }" />
            <div v-else class="hw24 text-white rounded-circle flex-center-center fw700 font12 text-capitalize" :style="{ border: '1px solid #F8FAFD', backgroundColor: getAvatarColor() }">
              {{ reviewData.author.username ? reviewData.author.username[0] : "D" }}
            </div>
          </template>
          <img v-if="revieweeData.image" class="rounded-circle hw70" :src="revieweeData.image" alt="dp" />
          <div v-else class="rounded-circle hw70 text-white flex-center-center fw700 font24" :style="{ backgroundColor: getAvatarColor(revieweeData.id) }">
            {{ revieweeData.name ? revieweeData.name[0] : "D" }}
            {{
              revieweeData.name &&
              revieweeData.name
                .split(" ")
                .slice(1)
                .join(" ")
                ? revieweeData.name
                    .split(" ")
                    .slice(1)
                    .join(" ")[0]
                : ""
            }}
          </div>
        </a-badge>
      </div>

      <div class="d-flex flex-column justify-content-center flex1">
        <div class="d-flex align-items-center mb-1 flex-wrap">
          <p class="gray900 fw700 font16 text-capitalize mr-2 mb-0">{{ revieweeData.name || "User" }}</p>
          <div class="d-flex align-items-center">
            <font-awesome-icon class="font18 text-black mr-2" :icon="['fal', 'star']" />
            <p class="font16 gray900 mb-0">has been reviewed</p>
          </div>
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <p class="mr-2 font16 gray900 mb-0">by {{ !reviewData.review_delete_url ? "Verified user" : "you" }}</p>
          <!-- <p class="mr-2 font16 gray900 mb-0">by {{ reviewData.author.username ? reviewData.author.username[0].toUpperCase() + reviewData.author.username.slice(1) : "User" }}</p> -->
          <p class="font12 gray400 mb-0">{{ time }}</p>
        </div>
      </div>

      <div class="show-in-mobile divider"></div>

      <div class="ratingContainer">
        <p class="mb-2 br8 py-1 px-2 font12 fw700" :style="{ color: getPrimaryColor(), background: getPrimary50Color(), 'max-width': 'fit-content' }">In person visit</p>
        <div class="d-flex align-items-center">
          <ReviewStar :width="24" :height="24" :rating="parseFloat(reviewData.overall)" />
          <p class="mb-0 font16 fw700 gray900 ml-2">{{ parseFloat(reviewData.overall).toFixed(1) }}</p>
        </div>
      </div>

      <font-awesome-icon @click="expanded = !expanded" class="cp gray400 font24 mt32" :icon="['fas', `${expanded ? 'angle-up' : 'angle-down'}`]" />
    </div>

    <template v-if="expanded">
      <hr class="mt-3 mx-0 hide-in-mobile" />
      <p class="mb-0 mt-3 gray500 font16">{{ reviewData.comment }}</p>
      <div class="d-flex flex-wrap gap16 mt-3 mob-grid">
        <div v-for="eachRating in individualRatings" :key="eachRating.name" class="br8 p-2 d-flex align-items-center bg-gray100 gray900 font12 fw700 gap8">
          {{ eachRating.name }}
          <ReviewStar :rating="eachRating.value" :height="16" :width="16" />
          <p class="mb-0 font12 fw700 gray900">{{ eachRating.value }}</p>
        </div>
        <div v-if="reviewData['length_of_visit']" class="br8 p-2 d-flex align-items-center bg-gray100 gap8">
          <span class="gray900 font12 fw700">Length of Visit</span>
          <span class="font12 fw700" :style="{ color: getPrimaryColor() }"> {{ getFullLength(reviewData["length_of_visit"]) }} </span>
        </div>
      </div>
      <button v-if="ownerView" class="p1224 br6 text-white font14 fw700 mt-3" :style="{ background: getPrimaryColor(), border: 'none' }" @click="reply">Reply</button>
      <div class="d-flex align-items-center w-100 mt-4 helpful flex-wrap">
        <span class="gray900 one"> Was this review helpful? </span>
        <span class="gray900 two">
          <font-awesome-icon :icon="[`${!reviewData.review_create_helpful_url ? 'fas' : 'fal'}`, 'thumbs-up']" class="cp" @click="reactReview('like')" />
          <font-awesome-icon :icon="[`${!reviewData.review_create_unhelpful_url ? 'fas' : 'fal'}`, 'thumbs-down']" class="ml-4 cp" @click="reactReview('dislike')" />
        </span>
        <span class="gray900 ml-auto cp three" @click="reactReview('flag')" v-if="reviewData.review_create_flag_url || reviewData.review_delete_flag_url">
          <font-awesome-icon :icon="[`${!reviewData.review_create_flag_url ? 'fas' : 'fal'}`, 'flag']" class="mr-2" />
          Flag Review
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import ReviewStar from "../../commons/ReviewStar.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faFilter, faFlag, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp } from "@fortawesome/pro-solid-svg-icons"

library.add(faFilter, faFlag, faThumbsDown, faThumbsUp, faAngleDown, faAngleUp)

export default {
  name: "ReviewCardCore",
  props: { reviewData: Object, ownerView: Boolean, getReviewsFromCore: Function },
  data() {
    return {
      seeMore: true,
      revieweeData: null,
      time: null,
      expanded: false,
      individualRatings: [],
      allRatings: [
        { name: "Clarity", key: "clarity" },
        { key: "friendliness_of_staff", name: "Friendliness Of The Staff" },
        { key: "nursing_care", name: "Nursing Care" },
        { key: "courtesy_of_stuff", name: "Courtesy Of Stuff" },
        { key: "cleanliness", name: "Cleanliness" },
        { key: "community_service", name: "Community Service" },
        { key: "appointment", name: "Ease of Appointment" },
        { key: "wait_time", name: "Wait Time" },
        { key: "friendliness", name: "Friendliness Of The Staff" },
        { key: "attentiveness", name: "Attentiveness" },
        { key: "quality_time", name: "Quality Time" },
        { key: "politeness", name: "Politeness" },
        { key: "knowledge", name: "Knowledge" },
      ],
    }
  },
  components: { ReviewStar },
  created() {
    // console.log("core review:", this.reviewData)
    this.revieweeData = this.getReviewee()
    this.time = this.formatPostTime(this.reviewData.published)
    this.getAllRatings()
    if (this.reviewData.comment && this.reviewData.comment.length > 200) {
      this.seeMore = false
    } else {
      this.seeMore = true
    }
  },
  methods: {
    getBadgeLength(a, b) {
      if (a && b) {
        return 50
      }
      if (!a && b) {
        return -20
      }
      if (a && !b) {
        return -20
      }
      return -20
    },
    goToProf() {
      window.open(`${process.env.SSO_BASE_URL}${this.revieweeData.ratingLink}`, "_blank")
    },
    async reply() {
      this.$notification.info({ message: "WIP", description: "Coming soon..." })
    },
    async reactReview(type) {
      let userType = '';
      if (this.reviewData.physician) {
        userType = 'physician';
      } else if (this.reviewData.ohcp) {
        userType = 'ohcp';
      } else if (this.reviewData.hospital) {
        userType = 'hospital';
      } else if (this.reviewData.clinic) {
        userType = 'clinic';
      }
      try {
        const headers = {
          Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`,
          dtoken: this.authUser.user.dovemed_csrf_token || this.authUser.user.dovemed_session_token,
        }
        switch (type) {
          case "flag":
            if (this.reviewData.review_create_flag_url) {
              await this.$http.post(`${process.env.SSO_BASE_URL}/api/v2/review/${userType}/review/${this.reviewData.id}/flag/`, null, { headers })
              this.reviewData.review_create_flag_url = false;
              this.reviewData.review_delete_flag_url = true;
              this.$notification.success({
                message: "Successful",
                description: `Flag saved`
              });
            } else if (this.reviewData.review_delete_flag_url) {
              await this.$http.delete(`${process.env.SSO_BASE_URL}/api/v2/review/${userType}/review/${this.reviewData.id}/flag/`, { headers })
              this.reviewData.review_create_flag_url = true;
              this.reviewData.review_delete_flag_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Flag unsaved`
              });
            }
            break
          case "like":
            if (this.reviewData.review_create_helpful_url) {
              await this.$http.post(`${process.env.SSO_BASE_URL}/api/v2/review/${userType}/review/${this.reviewData.id}/helpful/`, null, { headers })
              this.reviewData.review_create_helpful_url = false;
              this.reviewData.review_delete_helpful_url = true;
              this.reviewData.review_delete_unhelpful_url = false;
              this.reviewData.review_create_unhelpful_url = true;
              this.$notification.success({
                message: "Successful",
                description: `Helpful saved`
              });
            } else if (this.reviewData.review_delete_helpful_url) {
              await this.$http.delete(`${process.env.SSO_BASE_URL}/api/v2/review/${userType}/review/${this.reviewData.id}/helpful/`, { headers })
              this.reviewData.review_create_helpful_url = true;
              this.reviewData.review_delete_helpful_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Helpful unsaved`
              });
            }
            break
          case "dislike":
            if (this.reviewData.review_create_unhelpful_url) {
              await this.$http.post(`${process.env.SSO_BASE_URL}/api/v2/review/${userType}/review/${this.reviewData.id}/unhelpful/`, null, { headers })
              this.reviewData.review_create_unhelpful_url = false;
              this.reviewData.review_delete_unhelpful_url = true;
              this.reviewData.review_create_helpful_url = true;
              this.reviewData.review_delete_helpful_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Unhelpful saved`
              });
            } else if (this.reviewData.review_delete_unhelpful_url) {
              await this.$http.delete(`${process.env.SSO_BASE_URL}/api/v2/review/${userType}/review/${this.reviewData.id}/unhelpful/`, { headers })
              this.reviewData.review_create_unhelpful_url = true;
              this.reviewData.review_delete_unhelpful_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Unhelpful unsaved`
              });
            }
            break
        }
        // await this.getReviewsFromCore()
      } catch (e) {
        this.$notification.error({ message: "Error", description: "Please try again later." })
      }
    },
    getFullLength(len) {
      const LENGTHS = { lt15: "Less than 30 minutes", lt30: "30 - 60 minutes", hour: "More than an hour" }
      return LENGTHS[len]
    },
    getAllRatings() {
      this.allRatings.forEach(eachRate => {
        if (this.reviewData[eachRate.key]) {
          this.individualRatings.push({ name: eachRate.name, value: parseFloat(this.reviewData[eachRate.key]).toFixed(1) })
        }
      })
    },
    getReviewee() {
      if (this.reviewData.clinic_info) {
        return {
          name: this.reviewData.clinic_info.clinic_name,
          image: this.reviewData.clinic_info.picture,
          id: this.reviewData.clinic_info.id,
          ratingLink: this.reviewData.clinic_info.profile_link,
        }
      }
      if (this.reviewData.hospital_info) {
        return {
          name: this.reviewData.hospital_info.hospital_name,
          image: this.reviewData.hospital_info.picture,
          id: this.reviewData.hospital_info.id,
          ratingLink: this.reviewData.hospital_info.profile_link,
        }
      }
      if (this.reviewData.physician_info) {
        return {
          name: this.reviewData.physician_info.full_name + (this.reviewData.physician_info.title ? ", " + this.reviewData.physician_info.title : ""),
          image: this.reviewData.physician_info.picture,
          id: this.reviewData.physician_info.id,
          ratingLink: this.reviewData.physician_info.profile_link,
        }
      }
      if (this.reviewData.app_info) {
        return {
          name: this.reviewData.app_info.full_name + (this.reviewData.app_info.title ? ", " + this.reviewData.app_info.title : ""),
          image: this.reviewData.app_info.picture,
          id: this.reviewData.app_info.id,
          ratingLink: this.reviewData.app_info.profile_link,
        }
      }
      return {
        name: "D",
        id: 0,
        image: null,
        ratingLink: "www.dovemed.com",
      }
    },
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (this.isDateToday(d)) {
        return "Today"
      }
      if (Number.isNaN(seconds)) {
        return ""
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        return years + " years ago"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
img {
  object-fit: cover;
}
.divider {
  background: #e2e8f0;
  width: 100%;
  height: 1px;
  margin-block: 16px;
}
.shadow {
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
}
.two {
  margin-left: 24px;
}
@media screen and (max-width: 900px) {
  .helpful {
    .one {
      width: 100%;
      margin-bottom: 24px;
    }
    .two {
      margin-left: 0px;
    }
  }
  .mob-grid {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    div {
      flex-wrap: wrap;
    }
  }
}
.ratingContainer {
  margin-right: 24px;
  @media screen and (max-width: 900px) {
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/ReviewCardCore.vue